<template>
    <loading 
        v-model:active="isLoading" 
        :loader="'dots'">
        <template v-slot:default>
            <Spinner></Spinner>
        </template>
    </loading>
    <Toast position="top-center"/>
    <router-view />
</template>

<script>
    import { computed } from 'vue'
    import store from '@/store'

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import Spinner from '@/components/Spinner'

    export default {
        components: { Loading, Spinner },
        async created() {
            if (store.state.auth.token != '') {
                const parseToken = JSON.parse(atob(store.state.auth.token.split('.')[1]))
                const d = new Date(parseToken.iat*1000)
                const errorToken = new Date('2023-03-16 19:00:00')
                if (d < errorToken) {
                    localStorage.removeItem('vuex')
                    location.href = "/login"
                }
            }
            store.state.auth.token && await store.dispatch('auth/refreshToken')
        },
        setup() {
            const isLoading = computed(() => store.state.isLoading)

            return {
                isLoading
            }
        }
    }
</script>